import { render, staticRenderFns } from "./os_choice.vue?vue&type=template&id=52f3b83f&scoped=true&"
import script from "./os_choice.vue?vue&type=script&lang=js&"
export * from "./os_choice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3b83f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f3b83f')) {
      api.createRecord('52f3b83f', component.options)
    } else {
      api.reload('52f3b83f', component.options)
    }
    module.hot.accept("./os_choice.vue?vue&type=template&id=52f3b83f&scoped=true&", function () {
      api.rerender('52f3b83f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/parts/adv/os_select/os_choice.vue"
export default component.exports